import React from 'react';
import { ElementsRenderer } from '../shared';
import { TEXT_TYPE } from '../../constants';
import { useAuth, useStableMediaUrl } from '../../hooks';
import { getMediaBlob } from '../../utils/mediaSessionCache';
import AiReasonBanner from './AiReasonBanner';

const VideoReview = ({ question, response, answerStatus, answerScoreData }) => {
  const { elements, solution, id: questionId } = question;
  const { uploadedFile } = response;
  const { token } = useAuth();

  const blob = getMediaBlob({ fileKey: uploadedFile?.fileKey, questionId }) || null;
  const { mediaUrl, isLoading } = useStableMediaUrl({
    blob,
    fileKey: uploadedFile?.fileKey,
    questionId,
    token
  });

  return (
    <div className="katex-question w-full space-y-4 md:space-y-6">
      {answerScoreData && (
        <AiReasonBanner
          reason={answerScoreData.aiReason}
          answerStatus={answerStatus}
          score={answerScoreData.score || 0}
          maxScore={answerScoreData.maxScore || 0}
        />
      )}

      <div className="question-container text-base leading-relaxed text-foreground md:text-lg">
        <ElementsRenderer elements={elements} textType={TEXT_TYPE.TIPTAP} />
      </div>

      <div className="space-y-2">
        <h4 className="font-medium text-foreground">Your Recording</h4>
        {uploadedFile?.fileKey ? (
          isLoading ? (
            <p className="text-sm italic text-muted-foreground">Loading...</p>
          ) : mediaUrl ? (
            <video
              controls
              src={mediaUrl}
              className="aspect-video w-full max-w-lg rounded-lg bg-black"
              playsInline
            />
          ) : (
            <p className="text-sm italic text-muted-foreground">Failed to load recording.</p>
          )
        ) : (
          <p className="text-sm italic text-muted-foreground">No recording found.</p>
        )}
      </div>

      {solution?.elements?.length > 0 && (
        <div className="space-y-3 border-t border-border/60 pt-4">
          <h4 className="font-medium text-foreground">Detailed Solution</h4>
          <div className="text-sm leading-relaxed text-muted-foreground">
            <ElementsRenderer elements={solution.elements} textType={TEXT_TYPE.TIPTAP} />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoReview;
